import { fetchCurrentUser } from '@/service/user';
import { proxy, useSnapshot } from 'valtio';
import { getUserInfo } from '@/utils/token';
import type { ICurrentUser } from '@/service/user/types';

interface IRootStore {
  isLoading: boolean;
  current?: ICurrentUser;
  refresh: () => Promise<ICurrentUser>;
  reset: () => void;
}

const state = proxy<IRootStore>({
  isLoading: false,
  current: getUserInfo() && JSON.parse(getUserInfo()),
  /** 更新当前登录用户 */
  async refresh() {
    state.isLoading = true;
    const current = await fetchCurrentUser().finally(() => (state.isLoading = false));

    state.current = current;
    return current;
  },

  /** 重置 */
  reset() {
    state.isLoading = false;
    state.current = undefined;
  },
});

export const rootStore = state;

/** 获取用户全局状态 */
export const useSnapshotRoot = () => useSnapshot(rootStore) as IRootStore;
